import * as React from "react";
import { formatValueOnPlanAndTotalType } from "../pinned-row-helpers";
import { IPlanMetricDoorRendererProps } from "./plan-metric-door-column";
import classNames from "classnames";

export const DiffRow: React.FunctionComponent<IPlanMetricDoorRendererProps> = ({
    totalType,
    style,
    currency,
    planRowType,
    total,
    plan,
}) => {
    const diff = +(plan - total).toFixed(1);
    const value = formatValueOnPlanAndTotalType({ value: diff, totalType, currency, planRowType });
    const variance = diff === 0 ? 0 : plan > 0 ? Math.abs(diff) / plan : Number.POSITIVE_INFINITY;

    return (
        <div style={style} className="planCell">
            <div
                className={classNames("delta", {
                    great: variance < 0.02,
                    fair: variance >= 0.02 && variance < 0.05,
                    off: variance >= 0.05 && variance <= 0.1,
                    wayOff: variance > 0.1,
                })}
            >
                {`${diff > 0 ? "+" : ""}${value}`}
            </div>
        </div>
    );
};
